import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import user from './modules/user'
import packs from './modules/packs'
import localisation from './modules/localisation'
import settings from './modules/settings'
import providers from './modules/providers'
import charge from './modules/charge'
import vod from './modules/vod'
import rentals from './modules/rentals'
import device from './modules/device'
import otp from './modules/otp'
import route from './modules/route'

Vue.use(Vuex)
Vue.config.devtools = true

const vuexLocalStorage = new VuexPersistence({
    key: 'simplestream',
    storage: window.sessionStorage,
    modules: [
        'user',
        'packs',
        'providers',
        'settings',
        'charge',
        'vod',
        'rentals',
        'device',
        'otp',
    ],
})

export default new Vuex.Store({
    modules: {
        user,
        packs,
        localisation,
        settings,
        providers,
        charge,
        vod,
        rentals,
        device,
        otp,
        route,
    },
    plugins: [vuexLocalStorage.plugin],
})
